import { render, staticRenderFns } from "./DialogCreateNicknameAlias.vue?vue&type=template&id=193a14e6&scoped=true"
import script from "./DialogCreateNicknameAlias.js?vue&type=script&lang=js&external"
export * from "./DialogCreateNicknameAlias.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193a14e6",
  null
  
)

export default component.exports